import type { FC } from 'react';
import React from 'react';
import { Divider, Tag, Tooltip } from 'antd';
import type { NodeProps } from '../../types';
import { AssignmentNodeType } from './types';
import { TAG_TEXT_MAX_LENGTH } from '../constants';
import crudIconMap, { Color } from './config'
import { useWorkflowStore } from '../../store';

const Node: FC<NodeProps<AssignmentNodeType>> = (props) => {
  const { data } = props;
  const { detail, crudDatas = []} = data;

  const workflowStore = useWorkflowStore();
  const { prjData } = workflowStore.getState()

  return (
    <>
      <div className="px-3">
        {/* {detail.station && (
        <div className="relative h-0 text-right text-xs">
          <Tag
            className="!-right-[2px] !-top-[20px] !-translate-y-1/2"
            color="cyan"
          >
            {detail.station}
          </Tag>
        </div>
      )} */}
        {/* <div className="mb-1 text-center text-base font-medium">
          {detail.title}
        </div> */}
        {/* <div className="mb-2 indent-6 text-xs text-gray-400">
          {detail.resume}
        </div> */}
        <div></div>
      </div>
      <div className="space-y-0.5 mb-1">
        {crudDatas?.map((item) => (
          <div
            key={item.id}
            className="flex items-center rounded-md  bg-gray-100 px-1 py-0.5 mx-3"
          >
            <div className='w-5 h-full mr-1 flex items-center pr-1 border-r-[1px]'>{crudIconMap[item.type]}</div>
            
            <div className={'grow w-0'}>
              {item.data?.map((k) => (
                //最多显示10个字符，超出省略
                <Tag key={k} className='grow max-w-full truncate h-6 leading-6 flex-none align-middle' style={{ margin: '1px', color: '#000', borderColor: '#87e8de'}} title={k} color={Color.CYAN}>{k}</Tag>                
              ))}
            </div>
          </div>
        ))}
      </div>
      {detail.desc && (
        <div className="system-xs-regular whitespace-pre-line break-words px-3 pb-2 pt-1 text-text-tertiary">
          {detail.desc}
        </div>
      )}
      {prjData.bfTypeCode == 'TARGET' && detail.businessTags && detail.businessTags.length > 0 && (
        <div className="border-t-[1px] border-solid border-gray-200 px-3 pt-2">
          {detail.businessTags.map((tag: string) => {
            const isLongTag = tag.length > TAG_TEXT_MAX_LENGTH;
            const tagElem = (
              <Tag style={{ marginBottom: '2px' }} key={tag}>
                {isLongTag ? `${tag.slice(0, TAG_TEXT_MAX_LENGTH)}...` : tag}
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
        </div>
      )}
    </>
  );
};

export default React.memo(Node);
